import { useNavigate, useParams } from 'react-router-dom'
import { useCanJoinEvent } from './useCanJoinEvent'

export function useRedirectToCurrentEventState() {
  const navigate = useNavigate()
  const { storeId } = useParams()
  const { canBypassJoin } = useCanJoinEvent()

  function redirectToCurrentState(event) {
    const eventStatusUrl = new URL(window.location.href).pathname.split('/').pop()

    const thresholdSeconds = 3
    if (
      (event.finishAt !== null && new Date() > new Date(event.finishAt)) ||
      (event.finishedAt !== null && new Date() > new Date(event.finishedAt))
    ) {
      console.debug('Event has finished')
      if (eventStatusUrl !== 'finished') {
        console.debug('Redirecting to finished')
        return navigate(
          `/store/${storeId}/event/${event.eventId}/finished${window.location.search}`,
        )
      }
    } else if (event.secondsUntilJoin - thresholdSeconds <= 0) {
      console.debug('Event is started')
      if (eventStatusUrl !== 'live') {
        console.debug('Redirecting to live')
        return navigate(`/store/${storeId}/event/${event.eventId}/live${window.location.search}`)
      }
    } else if (event.secondsUntilJoin + thresholdSeconds > 0) {
      console.debug('Event is scheduled')
      if (canBypassJoin) {
        console.debug('User can bypass join, redirecting to live')
        return navigate(`/store/${storeId}/event/${event.eventId}/live${window.location.search}`)
      }
      if (eventStatusUrl !== 'scheduled') {
        console.debug('Redirecting to scheduled')
        return navigate(
          `/store/${storeId}/event/${event.eventId}/scheduled${window.location.search}`,
        )
      }
    }
  }

  return {
    redirectToCurrentState,
  }
}
